export const brandServiceKeywords: Record<string, Record<string, string[]>> = {
  'lg': {
    'ac-repair': [
      'Window AC',
      'Split AC', 
      'Cassette AC',
      'Inverter AC',
      'Portable AC',
      'Installation',
      'Gas Refilling',
      'PCB Repair'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'French Door',
      'Smart Fridge',
      'Inverter Technology',
      'Water Dispenser'
    ],
    'washing-machine-repair': [
      'Semi Automatic',
      'Fully Automatic',
      'Top Load',
      'Front Load',
      'Smart Washer',
      'Installation'
    ],
    'tv-repair': [
      'LED TV',
      'OLED TV',
      'LCD TV',
      'HD TV',
      '3D TV',
      '4K TV',
      '8K TV',
      'Smart TV',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Smart Microwave'
    ],
    'water-purifier-repair': [
      'RO Purifier',
      'UV Purifier',
      'UF Purifier',
      'Installation',
      'Filter Change'
    ]
  },
  'samsung': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Smart AC',
      'Installation',
      'Gas Refilling'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'French Door',
      'Smart Fridge',
      'Digital Inverter'
    ],
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Smart Washer',
      'AddWash',
      'Installation'
    ],
    'tv-repair': [
      'LED TV',
      'QLED TV',
      'Neo QLED',
      '4K TV',
      '8K TV',
      'Smart TV',
      'Frame TV',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Smart Oven'
    ]
  },
  'whirlpool': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      '6th Sense AC',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Multi-Door',
      'Bottom Freezer',
      'Frost Free'
    ],
    'washing-machine-repair': [
      'Semi Automatic',
      'Fully Automatic',
      'Top Load',
      'Front Load',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Jet Crisp'
    ]
  },
  'godrej': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free',
      'Direct Cool'
    ],
    'washing-machine-repair': [
      'Semi Automatic',
      'Fully Automatic',
      'Top Load',
      'Front Load',
      'Installation'
    ],
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      'HD TV',
      '4K TV',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave'
    ]
  },
  'voltas': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Cassette AC',
      'Tower AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling',
      'PCB Repair'
    ]
  },
  'daikin': {
    'ac-repair': [
      'Split AC',
      'Cassette AC',
      'VRV System',
      'Inverter AC',
      'Installation',
      'Gas Refilling',
      'PCB Repair'
    ]
  },
  'hitachi': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ],
    'refrigerator-repair': [
      'Double Door',
      'Side by Side',
      'Multi-Door',
      'Bottom Freezer'
    ]
  },
  'carrier': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Cassette AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ]
  },
  'haier': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Bottom Freezer'
    ],
    'washing-machine-repair': [
      'Fully Automatic',
      'Top Load',
      'Front Load',
      'Installation'
    ]
  },
  'videocon': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Installation',
      'Gas Refilling'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Frost Free',
      'Direct Cool'
    ],
    'washing-machine-repair': [
      'Semi Automatic',
      'Fully Automatic',
      'Top Load',
      'Installation'
    ],
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'HD TV',
      'Installation'
    ]
  },
  'bluestar': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Cassette AC',
      'Inverter AC',
      'Commercial AC',
      'Installation',
      'Gas Refilling'
    ],
    'water-purifier-repair': [
      'RO Purifier',
      'UV Purifier',
      'Installation',
      'Filter Change'
    ],
    'refrigerator-repair': [
      'Deep Freezer',
      'Commercial Refrigerator',
      'Water Cooler',
      'Visi Cooler'
    ]
  },
  'bosch': {
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Installation',
      'Motor Repair',
      'PCB Repair'
    ],
    'refrigerator-repair': [
      'Double Door',
      'Side by Side',
      'Bottom Freezer',
      'Frost Free'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Built-in Microwave'
    ]
  },
  'bpl': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'CRT TV',
      'Smart TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Direct Cool',
      'Frost Free'
    ]
  },
  'croma': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ],
    'washing-machine-repair': [
      'Fully Automatic',
      'Semi Automatic',
      'Top Load',
      'Front Load'
    ]
  },
  'electrolux': {
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Steam Wash',
      'Installation'
    ],
    'refrigerator-repair': [
      'Double Door',
      'Side by Side',
      'Bottom Freezer',
      'Frost Free'
    ]
  },
  'ge': {
    'refrigerator-repair': [
      'Side by Side',
      'French Door',
      'Bottom Freezer',
      'Smart Refrigerator'
    ],
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Smart Washer',
      'Installation'
    ],
    'microwave-repair': [
      'Countertop Microwave',
      'Built-in Microwave',
      'Over-the-Range',
      'Smart Microwave'
    ]
  },
  'gem': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Direct Cool',
      'Frost Free'
    ]
  },
  'hyundai': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ],
    'washing-machine-repair': [
      'Fully Automatic',
      'Semi Automatic',
      'Top Load',
      'Front Load'
    ]
  },
  'ifb': {
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Steam Wash',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Built-in Microwave'
    ]
  },
  'kelvinator': {
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Direct Cool',
      'Frost Free',
      'Deep Freezer'
    ]
  },
  'kenstar': {
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Installation'
    ]
  },
  'koryo': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation'
    ]
  },
  'lloyd': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ],
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ]
  },
  'midea': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ]
  },
  'mitsubishi': {
    'ac-repair': [
      'Split AC',
      'Cassette AC',
      'VRF System',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ]
  },
  'napoleon': {
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Installation'
    ]
  },
  'ogeneral': {
    'ac-repair': [
      'Split AC',
      'Cassette AC',
      'VRF System',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ]
  },
  'onida': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      'Installation'
    ],
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation'
    ]
  },
  'panasonic': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Installation'
    ]
  },
  'philips': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Installation'
    ]
  },
  'sansui': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      'HD TV',
      'Installation'
    ]
  },
  'sanyo': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Frost Free',
      'Direct Cool'
    ]
  },
  'sharp': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'microwave-repair': [
      'Solo Microwave',
      'Grill Microwave',
      'Convection Microwave',
      'Installation'
    ],
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ]
  },
  'siemens': {
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Steam Wash',
      'Installation'
    ],
    'refrigerator-repair': [
      'Double Door',
      'Side by Side',
      'Bottom Freezer',
      'Frost Free'
    ]
  },
  'tcl': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'QLED TV',
      'Installation'
    ],
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation'
    ]
  },
  'toshiba': {
    'tv-repair': [
      'LED TV',
      'LCD TV',
      'Smart TV',
      '4K TV',
      'Installation'
    ],
    'refrigerator-repair': [
      'Double Door',
      'Side by Side',
      'Multi-Door',
      'Frost Free'
    ],
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Installation'
    ]
  },
  'vestar': {
    'ac-repair': [
      'Window AC',
      'Split AC',
      'Inverter AC',
      'Installation',
      'Gas Refilling'
    ]
  },
  'white-westinghouse': {
    'refrigerator-repair': [
      'Single Door',
      'Double Door',
      'Side by Side',
      'Frost Free'
    ],
    'washing-machine-repair': [
      'Front Load',
      'Top Load',
      'Fully Automatic',
      'Installation'
    ]
  }
};